import { Heading, Flex, Button, Text } from "@radix-ui/themes";
import { useState } from "react";
import Countdown from "react-countdown";
import { useTranslation } from "react-i18next";
import { SUCCESS_MODAL_AUTO_CLOSE_TIMEOUT } from "../../../shared/consts";

type CheckoutSuccessfulProps = {
  onPrintReceipt?: () => void;
  onClose: () => void;
  amount?: string;
};

export function CheckoutSuccessful({
  onClose,
  amount,
}: CheckoutSuccessfulProps) {
  const [closeDate] = useState(
    () => Date.now() + SUCCESS_MODAL_AUTO_CLOSE_TIMEOUT,
  );
  const { t } = useTranslation(undefined, { lng: "tr" });

  return (
    <div className="flex flex-col w-full items-center justify-center h-full p-8">
      <Flex className="flex-grow" direction="column" justify="center">
        <figure className="flex justify-center">
          <img
            src="/success.png"
            className="size-[150px] pointer-events-none select-none"
          />
        </figure>
        <Heading
          size="6"
          mb="2"
          className="!text-3xl"
          align="center"
          weight="bold"
          color="gray"
          highContrast
        >
          {t("checkoutCompleted")}
        </Heading>
        {!!amount && (
          <Flex direction="column" gap="3" mb="6">
            <Text as="p" size="5" align="center" color="gray">
              {t("amount")}: {amount}
            </Text>
          </Flex>
        )}
      </Flex>

      <Flex
        className="w-full"
        direction="column"
        justify="between"
        gap="2"
        mt="4"
        px="4"
      >
        <Button
          size="4"
          className="!basis-[calc(50%-0.5rem)] !min-h-14 !rounded-2xl"
          variant="solid"
          highContrast
          radius="large"
          color="gray"
          onClick={onClose}
        >
          {t("closeCheckout")}{" "}
          <Countdown
            date={closeDate}
            onComplete={onClose}
            renderer={({ seconds }) => <>({seconds} s)</>}
          ></Countdown>
        </Button>
      </Flex>
    </div>
  );
}
